
/**
 * CreatePatrimonioChecklistMaquinaEquipUseCase
 */

import { ICreatePatrimonioChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/create/create_patrimonio_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class CreatePatrimonioChecklistMaquinaEquipUseCase implements ICreatePatrimonioChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createPatrimonioChecklistMaquinaEquip(
    idPatrimonioCentroCusto: number | null,
    idChecklistMaquinaEquip: number | null,
    idPatrimonioMaquinaEquip: number | null,
    metaAprovacao: number | null,
    status: number | null,
  ): Promise<number> {
    return await this.repository.createPatrimonioChecklistMaquinaEquip(
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      idPatrimonioMaquinaEquip,
      metaAprovacao,
      status,
    );
  }
}
